import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

//components
import { FaFolderOpen } from "react-icons/fa";
import { Spinner, Row } from "react-bootstrap";
import { ListContent } from "../favorites-list/styles"

//services
import { listFavoriteUnities } from "../../../../services/favorites.service"
import { CardList } from "../../../../components/card-list";
import { IListFavorites } from "../models/IListFavorites";
import { getStorageFavoriteMaterials } from "../../../../utils/storageFavoriteMaterials";


export const UnityFavorites: React.FC<IListFavorites> = ({ removeFavorite, listFilter, isAuth }) => {
  const { t: translation } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [unities, setUnities] = useState([]);

  useEffect(() => {

    if (isAuth) {

      listFavoriteUnities(listFilter).then((resp: any) => {
        setUnities(resp.results);
      }).finally(() => {
        setLoading(false);
      })

    } else {
      const favoriteMaterials = getStorageFavoriteMaterials('@favorites_items')
      if (favoriteMaterials) {
        listFilter.favorites = favoriteMaterials
      }
      setLoading(true)
      listFavoriteUnities(listFilter).then((resp: any) => {
        setUnities(resp.results);
      }).finally(() => {
        setLoading(false);
      })

    }

  }, [listFilter, isAuth])


  if (loading) {
    return (
      <div className="loading-container mt-5">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  return (
    <Row>
      <ListContent>
        {
          unities.length === 0 ? (
            <div className="text-center text-grey mt-5">
              <FaFolderOpen className="mt-5" size={150} />
              <h5>{translation("favorites.emptyUnities")}</h5>
            </div>
          ) :
            (
              unities.map((unity: any) => (
                <CardList key={unity.favorite_id} material={unity} isMaterialView={true} removeFavorite={removeFavorite} />
              ))
            )
        }
      </ListContent>
    </Row>
  )
}